export const TP_LINKS = {
  PRIVACY_POLICY_URL: 'https://www.truckerpath.com/privacy-policy',
  TERMS_OF_SERVICE_URL: 'https://www.truckerpath.com/terms-of-service',
  TP_INSURANCE_URL: 'https://truckerpath.com/insurance',
};
